import { render, staticRenderFns } from "./followupStepForm.vue?vue&type=template&id=ca2b3650"
import script from "./followupStepForm.vue?vue&type=script&lang=js"
export * from "./followupStepForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports